import React from "react";
import { ArrowRight, Upload, Sparkles } from "lucide-react";

export default function TwoWaysSection() {
  const options = [
    {
      num: "1",
      title: "I already have my design",
      desc: "Upload your image, logo, artwork, or idea and we'll prep it for print.",
      tags: ["PNG", "JPG", "Logo", "Artwork", "Photo"],
      cta: "Upload my design",
      icon: Upload,
      note: null,
    },
    {
      num: "2",
      title: "Design it for me",
      desc: "Tell us what you want and our team will create the design for you.",
      tags: ["Describe your idea", "Add an inspiration photo", "We send a proof first"],
      cta: "Start my custom design",
      icon: Sparkles,
      note: "Design fee applies. Design service is an additional fee, quoted with your proof.",
    },
  ];
  return (
    <section className="bg-[color:var(--dms-cream)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Two ways to order</p>
        <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4">How do you want your shirt?</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
      </div>
      <div className="max-w-6xl mx-auto px-5 lg:px-8 mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {options.map((o) => {
          const Icon = o.icon;
          return (
            <div key={o.num} className="bg-white rounded-2xl border border-[color:var(--dms-navy)]/10 p-8 hover-lift">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-[color:var(--dms-peach)] flex items-center justify-center text-[color:var(--dms-navy)] font-serif text-xl">{o.num}</div>
                <Icon className="w-5 h-5 text-[color:var(--dms-navy)]/40" />
              </div>
              <h3 className="font-serif text-2xl text-[color:var(--dms-navy)] mt-6">{o.title}</h3>
              <p className="text-[color:var(--dms-navy)]/70 mt-3 leading-relaxed">{o.desc}</p>
              <div className="mt-5 flex flex-wrap gap-2">
                {o.tags.map((t) => (
                  <span key={t} className="px-3 py-1 rounded-full bg-[color:var(--dms-cream-2)] border border-[color:var(--dms-navy)]/10 text-[color:var(--dms-navy)] text-xs">{t}</span>
                ))}
              </div>
              {o.note && <p className="mt-5 text-sm text-[color:var(--dms-navy)]/60"><strong className="text-[color:var(--dms-navy)]">Design fee applies.</strong> {o.note.replace("Design fee applies. ", "")}</p>}
              <div className="mt-6">
                <a href="#custom" className="link-peach">{o.cta} <ArrowRight className="w-4 h-4" /></a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
